import { c as _c } from "react/compiler-runtime";
import type { ComponentType } from 'react';
import { useAnalytics } from '@/hooks/useAnalytics';
type TileComponent = ComponentType<{
  className?: string;
  onClick?: () => void;
  description?: string;
}>;
type SpecialPage = 'sleep' | 'inspiration' | 'steve' | 'closet' | 'fantasy' | 'mac' | 'rotation' | 'museum' | 'bricks';

/**
 * Wraps a craft tile so a click fires the `special_page_interaction` analytics
 * event for that page. Every tracked tile was the same 12-line copy before.
 */
export function createTrackedTile(Tile: TileComponent, page: SpecialPage) {
  function TrackedTile(t0) {
    const $ = _c(6);
    const {
      className,
      description
    } = t0;
    const {
      track
    } = useAnalytics();
    let t1;
    if ($[0] !== track) {
      t1 = () => track("special_page_interaction", {
        page,
        action: "tile_click",
        details: "from_craft_page"
      });
      $[0] = track;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== className || $[3] !== description || $[4] !== t1) {
      t2 = <Tile className={className} description={description} onClick={t1} />;
      $[2] = className;
      $[3] = description;
      $[4] = t1;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  TrackedTile.displayName = `${page}TileTracked`;
  return TrackedTile;
}